import { useIsMobile } from "../../hooks/useMediaQuery";

export function RouteByDevice({
  mobile,
  desktop,
}: {
  mobile: React.ReactNode;
  desktop: React.ReactNode;
}) {
  const isMobile = useIsMobile();
  return isMobile ? mobile : desktop;
}
